<template>
  <h2 class="sign-title">
    <slot />
  </h2>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.sign-title {
  //font-family: 'PT Serif';
  font-size: 20px;
  font-style: italic;
  font-weight: 400;
  line-height: 135%;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 16px;
  @include point-lg {
    font-size: 24px;
  }
}
</style>
